/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Value_Memory_DescInputs */



/**
* | output |
* | --- |
* | "What was discussed stays on record, so your next conversation always has something to build on: what to say, and how to approach it." |
*
* @param {Onboarding_Value_Memory_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_value_memory_desc = /** @type {((inputs?: Onboarding_Value_Memory_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Value_Memory_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wat besproken is blijft bewaard, zodat je in een volgend gesprek handvaten hebt over wat te zeggen en hoe je het aanpakt.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce qui a été dit reste conservé : à la conversation suivante, vous savez quoi dire et comment vous y prendre.")
	return /** @type {LocalizedString} */ ("What was discussed stays on record, so your next conversation always has something to build on: what to say, and how to approach it.")
});